/** @jsx isolateComponent */

import { Fragment } from 'react';

import { Divider } from '@zapier/common-components';
import { Currency, PlanV2 } from '@zapier/design-system-revenue/src/types';
import { isolateComponent } from '@zapier/common-utils';

import { PlanPrice } from './PlanPrice';
import { PlanTitle } from './PlanTitle';

type PlanSummaryProps = {
  currency: Currency;
  description?: string | null;
  /** An array of identical plans with different variants */
  planVariants: PlanV2[];
  title: string;
};

/**
 * A component that shows a plan's pricing, title, and description.
 */
export const PlanSummary = ({
  currency,
  description,
  planVariants,
  title,
}: PlanSummaryProps) => (
  <Fragment>
    <PlanPrice currency={currency} planVariants={planVariants} />
    <Divider />
    <PlanTitle description={description} title={title} />
  </Fragment>
);
